<template>
<login-wrapper title="Forgot Password">
  <div>
    <h3 v-if="showNotification" class="notification" :class="notificationStyle">{{ notification }}</h3>
    <template v-if="!uuid">
      <p>Enter your registered email for password reset instructions.</p>
      <ForgotPassword></ForgotPassword>
    </template>

    <template v-if="uuid && !completed && status == 'ok'">
      <p>Please enter the PIN from the email we just sent.</p>
      <ResetPasswordPin></ResetPasswordPin>
    </template>

    <template v-if="uuid && !completed && status == 'valid'">
      <p>Enter new password for <strong>{{ email }}</strong>.</p>
      <ChangePassword></ChangePassword>
    </template>

    <template v-if="status == 'completed'">
      <div class="back-wrapper">
        <div class="back" @click="backToLogin">
          Back to login
          <md-icon>exit_to_app</md-icon>
        </div>
      </div>
    </template>

    
  </div>
  

</login-wrapper>
</template>


<script>
// import { MdCard } from 'vue-material/dist/components'
import LoginWrapper from '../components/LoginWrapper.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ResetPasswordPin from '../components/ResetPasswordPin.vue'
import ChangePassword from '../components/ChangePassword.vue'

// import LoginContainer from '../components/LoginContainer.vue'

import { mapState } from 'vuex'


export default {
  components: {LoginWrapper, ForgotPassword, ResetPasswordPin, ChangePassword},

  computed: {
    ...mapState(['completed', 'status', 'uuid', 'email', 'notification', 'showNotification']),
    notificationStyle() {
      return {
        'notification--error': this.status == 'error',
      }
    }
  },

  methods: {
    backToLogin() {
      console.log('taskstreamClose')
    }
  }
}
</script>

<style lang="scss">
.md-title {
    margin-top: 2em;
}

.notification {
    font-weight: bold;
    color: #2ccc2c;;

    &--error {
        color: red !important;
    }
}

.back-wrapper {
    display: flex;
    text-transform: uppercase;
    margin-top: 4em;
    margin-bottom: 2em;
    font-size: 20px;
    padding: 1em;
    justify-content: space-around;

    .back {
        flex: 0;
        background-color: #584C79;
        color: white;
        border-radius: 30px;
	flex-basis: auto;
	padding: 1em;
	padding-left: 1.5em;
	padding-right: 1.5em;
	cursor: pointer;
	padding-top: 1.1em;

        .md-icon {
            color: white !important;
            font-size: 31px !important;
            margin-left: 0.5em;
        }
    }
}

</style>
